import React, { Component } from 'react';
import Layout from '../../../Layouts/DefaultLayout';
import * as PostActions from '../../../../redux/post/actions';
import { Breadcrumb, Row, Col, Container, Image, Form, Button, Spinner } from 'react-bootstrap';
import * as BMOActions from '../../../../redux/bmos/actions';
import OtherOfferingsCarousel from '../../../Layouts/Partials/OtherOfferingsCarousel';
import ResourcesCarousel from '../../../Layouts/Partials/ResourcesCarousel';
import ExploreOperators from '../../../Layouts/Partials/ExploreOperators';
import _ from 'lodash'

class BMOViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            data: null,
            isLoading: false,
            data_allOfferings: [],
            data_allResources: [],
            msg: ""
        }
    }

    componentDidMount = async () => {
        let slug = this.props.match.params.id;
        if (slug !== undefined) {
            this._loadBMO(slug);
        } else {
            this.backToList();
        }

    }


    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }

    _loadBMO = async (slug) => {
        this.setState({ isLoading: true });
        let resp = await BMOActions.searchBMOJson(this.props.token, slug);
        if (resp.state) {
            this.setState({ isLoading: false, data: resp.data }, () => {
                this._handleAllOfferingsByBMO(resp.data['term_id'])
            });
        } else {
            this.setState({ isLoading: false }, () => this.backToList());
        }
    }

    _handleAllOfferingsByBMO = async (bmo) => {

        this.setState({ isLoading: true }, () => this._handleAllResourcesByBMO(bmo));

        let reqobj = {};
        reqobj['env'] = process.env.REACT_APP_MODE;
        reqobj['posts_per_page'] = 4;
        reqobj['post-type'] = 'offering';
        reqobj['bmos'] = [bmo];
        let resp = await PostActions.getAnyPostsJSON(this.props.token, 1, reqobj);
        if (resp.status) {
            this.setState({ data_allOfferings: resp.data.data }, () => {
                this.setState({ isLoading: false })
            });
        } else {
            this.setState({ isLoading: false })
        }

    }
    _handleAllResourcesByBMO = async (bmo) => {

        this.setState({ isLoading: true });

        let reqobj = {};
        reqobj['env'] = process.env.REACT_APP_MODE;
        reqobj['posts_per_page'] = 4;
        reqobj['post-type'] = 'post';
        reqobj['bmos'] = [bmo];
        let resp = await PostActions.getAnyPostsJSON(this.props.token, 1, reqobj);
        if (resp.status) {
            this.setState({ data_allResources: resp.data.data }, () => {
                this.setState({ isLoading: false })
            });
        } else {
            this.setState({ isLoading: false })
        }

    }

    backToList = () => {
        this.props.history.push(`/operators`);
    }

    _submitMailToBMO = async (e, bmoid) => {
        e.preventDefault();
        if (this.state.msg !== "") {
            this.setState({ isLoading: true });
            const formdata = {
                "sender-mail": this.props.usermail,
                "bmoid": bmoid,
                "msg": this.state.msg
            }
            const resp = await BMOActions.sendMailToBMOJson(this.props.token, formdata);
            this.setState({ isLoading: false, msg: "" });
        }
    }

    render = () => {
        const operator = this.state.data;
        return (
            <Layout>
                {(operator !== null) && (
                    <React.Fragment>
                        <Container>
                            <Breadcrumb className="mt-4">
                                <Breadcrumb.Item href="/resources">{`Operators`}</Breadcrumb.Item>
                                <Breadcrumb.Item href={`/resources/${operator.slug}`}>{`${operator.slug}`}</Breadcrumb.Item>
                            </Breadcrumb>
                            <h1>{operator.name}</h1>
                            <Row>
                                <Col md={3}>
                                    {(operator.acf !== false && operator.acf.logo !== undefined && operator.acf.logo.value !== false) && (
                                        <Image src={operator.acf.logo.value.sizes['logo']} fluid />
                                    )}

                                </Col>
                                <Col md={9}>
                                    {(operator.acf !== false && operator.acf.header_image !== undefined && operator.acf.header_image.value !== false) && (
                                        <Image src={operator.acf.header_image.value.sizes['bmo-partner-header']} fluid />
                                    )}
                                </Col>
                            </Row>
                            {(this.state.data_allOfferings.length > 0) && (
                                <OtherOfferingsCarousel isReadMoreEnable={true} data={this.state.data_allOfferings} bmo_slug={operator.slug} title={`All Offerings by ${operator.name}`} />
                            )}
                            {(this.state.data_allResources.length > 0) && (
                                <ResourcesCarousel isReadMoreEnable={true} data={this.state.data_allResources} bmo_slug={operator.slug} title={`All Resources by ${operator.name}`} />
                            )}
                        </Container>
                        <div className="my-4 py-4 request-info text-center">
                            <h3>Can’t find what you’re looking for?</h3>
                            <p>Enter the product name or your question below and we’ll get back to you!</p>
                            {(this.state.isLoading ) && (
                            
                               <Spinner animation="grow" />
                            )}
                            {(this.state.isLoading === false) && (
                                <Form onSubmit={(e) => this._submitMailToBMO(e, operator.term_id)}>
                                    <Form.Control as="textarea" rows="3" value={this.state.msg} onChange={(e) => this.setState({ msg: e.target.value })} />
                                    <Button variant="primary" className="mt-3" type="submit" block>Submit</Button>
                                </Form>
                            )}

                        </div>
                        <div className="product-expert">
                            <h3 className="text-center">Or talk to our product expert</h3>
                            <Row className="my-4">
                                <Col xs={4}>
                                    <Image className="img-fluid" roundedCircle src={operator.acf.expert_photo && operator.acf.expert_photo.value ? operator.acf.expert_photo.value.sizes.thumbnail : ""} />
                                </Col>
                                <Col xs={8}>
                                    <div><b>{operator.acf.expert_first_name.value} {operator.acf.expert_last_name.value}</b></div>
                                    <div>{operator.acf.expert_email.value}</div>
                                    {(operator.acf.expert_email.value !== operator.acf.email.value) && (
                                        <div>{operator.acf.email.value}</div>
                                    )}

                                    {/*commented - Fix for Operator click issue*/}
                                    {/*<div className="mt-2">
                                        {operator.acf.expert_phone.value?operator.acf.expert_phone.value:""}
                                    </div>*/}

                                    {/*Fix for Operator click issue*/}
                                    {(operator.acf.expert_phone !== undefined) && (
                                    <div className="mt-2">
                                        {operator.acf.expert_phone.value?operator.acf.expert_phone.value:""}
                                    </div>
                                    )}
                                    {/*Fix for Operator click issue*/}

                                    <div className="mt-4"><b>Website: </b><a target="_blank" href={operator.acf.website.value}>{operator.acf.website.value}</a></div>
                                </Col>
                            </Row>
                        </div>
                        <Container fluid>
                        <Row className="expore-more-container">
                            <Col xs={12}>
                                    <ExploreOperators
                                        currentOperatorID={operator.term_id}
                                        token={this.props.token}
                                    />
                            </Col>
                        </Row>
                        </Container>

                    </React.Fragment>
                )}

            </Layout>
        );
    };



}


/* Export Component ==================================================================== */
export default BMOViewContainer;